export default "__VITE_ASSET__ca9d612a__"